import * as React from 'react'
import type { CSSProperties } from 'react'

import { cn } from '@/lib/utils'

/**
 * <Kbd> - keyboard shortcut hint.
 *
 * Used inline next to button labels to communicate keyboard accelerators
 * (e.g. "Approve" [A]).
 */
export const Kbd = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, children, style, ...props }, ref) => (
    <kbd
      ref={ref}
      style={{ ...styles.kbd, ...style }}
      className={cn('mono', className)}
      {...props}
    >
      {children}
    </kbd>
  )
)
Kbd.displayName = 'Kbd'

const styles: Record<string, CSSProperties> = {
  kbd: {
    display: 'inline-flex',
    height: '20px',
    minWidth: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: '1px solid var(--border-default)',
    background: 'var(--bg-tertiary)',
    padding: '0 6px',
    fontSize: '10px',
    fontWeight: 500,
    color: 'var(--text-secondary)',
  },
}
